/**
 * Non-hat top-level blocks that must never be auto-started by the Go button. Hat blocks are
 * filtered out separately via runtime.getIsHat; these are the top-level opcodes that are
 * *definitions* rather than runnable scripts, so starting them would execute a custom
 * block's body once on every press.
 * @type {Array.<string>}
 */
const NON_RUNNABLE_TOP_LEVEL_OPCODES = ['procedures_definition'];

/**
 * Run a BrickLab project, as triggered by the green flag / Go button.
 *
 * Stock Scratch starts only the stacks topped by a `when green flag clicked` hat, so a bare
 * stack with no hat sits there doing nothing until it is clicked directly. BrickLab learners
 * build bare stacks, so Go additionally starts every top-level stack that has no hat of its
 * own, across every target.
 *
 * Stacks topped by some *other* hat (`when key pressed`, `when I receive`, `when I start as
 * a clone`, ...) are deliberately left alone - those have their own trigger and firing them
 * on Go would break their meaning.
 *
 * @param {VirtualMachine} vm the VM whose project should run
 */
const runProject = function (vm) {
    // greenFlag() stops everything first and then starts the whenflagclicked hats, so by the
    // time the hatless stacks are added below there is nothing left running to collide with,
    // and the toggle below can only ever mean "start".
    vm.greenFlag();

    const runtime = vm.runtime;
    runtime.targets.forEach(target => {
        const blocks = target.blocks;
        // Copy: toggleScript starts threads while we iterate the container's own array.
        blocks.getScripts().slice()
            .forEach(topBlockId => {
                const block = blocks.getBlock(topBlockId);
                if (!block) return;

                const opcode = blocks.getOpcode(block);
                if (runtime.getIsHat(opcode)) return;
                if (NON_RUNNABLE_TOP_LEVEL_OPCODES.indexOf(opcode) !== -1) return;

                runtime.toggleScript(topBlockId, {target: target});
            });
    });
};

export default runProject;
